<div class="stay-box">
  <input
    #box
    [id]="inputId"
    [attr.data-testid]="inputId"
    type="text"
    inputmode="numeric"
    autocomplete="off"
    maxlength="5"
    class="p-inputtext p-component w-full"
    [value]="text"
    [placeholder]="inherited || ('SETTINGS.LABELS.STAY.FORMAT' | translate)"
    [disabled]="!canEdit"
    (input)="onInput(box.value, box)"
    (keydown)="onKey($event)"
    (click)="canEdit && panel.show($event, box)"
    (blur)="onBlur()"
  />
  @if (canEdit) {
    <button
      type="button"
      class="stay-box__open"
      [attr.data-testid]="inputId + '-open'"
      [attr.aria-label]="'SETTINGS.LABELS.STAY.OPEN' | translate"
      (click)="panel.toggle($event, box)"
    >
      <i class="pi pi-clock" aria-hidden="true"></i>
    </button>
  }
</div>
@if (invalid) {
  <small class="p-error" style="display: block" [attr.data-testid]="inputId + '-error'">{{ 'SETTINGS.LABELS.STAY.RANGE_ERROR' | translate }}</small>
} @else if (mode === 'role') {
  <small class="color-gray2" style="display: block">{{ 'SETTINGS.LABELS.STAY.ROLE_HINT' | translate }}</small>
} @else if (inherited) {
  <small class="color-gray2" style="display: block" [attr.data-testid]="inputId + '-hint'">{{ 'SETTINGS.LABELS.STAY.PASS_HINT_ROLE' | translate: { value: inherited } }}</small>
} @else {
  <small class="color-gray2" style="display: block" [attr.data-testid]="inputId + '-hint'">{{ 'SETTINGS.LABELS.STAY.PASS_HINT_NONE' | translate }}</small>
}

<!-- above the drawers (10001) and dialog masks (10050), like the select overlays in styles.scss -->
<p-popover #panel [focusOnShow]="false" [baseZIndex]="10100">
  <div class="stay-panel" [attr.data-testid]="inputId + '-panel'">
    <div class="stay-panel__steppers" dir="ltr">
      <div class="stay-panel__unit">
        <small>{{ 'SETTINGS.LABELS.STAY.HOURS' | translate }}</small>
        <button type="button" [attr.data-testid]="inputId + '-hours-up'" (mousedown)="$event.preventDefault()" (click)="step(60)"><i class="pi pi-chevron-up"></i></button>
        <b>{{ parts.hours }}</b>
        <button type="button" [attr.data-testid]="inputId + '-hours-down'" (mousedown)="$event.preventDefault()" (click)="step(-60)"><i class="pi pi-chevron-down"></i></button>
      </div>
      <b class="stay-panel__colon">:</b>
      <div class="stay-panel__unit">
        <small>{{ 'SETTINGS.LABELS.STAY.MINUTES' | translate }}</small>
        <button type="button" [attr.data-testid]="inputId + '-minutes-up'" (mousedown)="$event.preventDefault()" (click)="step(5)"><i class="pi pi-chevron-up"></i></button>
        <b>{{ parts.minutes }}</b>
        <button type="button" [attr.data-testid]="inputId + '-minutes-down'" (mousedown)="$event.preventDefault()" (click)="step(-5)"><i class="pi pi-chevron-down"></i></button>
      </div>
    </div>
    <div class="stay-panel__presets">
      @for (minutes of presets; track minutes) {
        @let label = presetLabel(minutes);
        <button type="button" [class.active]="value === minutes" [attr.data-testid]="inputId + '-preset-' + minutes" (mousedown)="$event.preventDefault()" (click)="set(minutes); panel.hide()">
          {{ label.key | translate: label.params }}
        </button>
      }
    </div>
    <button type="button" class="stay-panel__clear" [attr.data-testid]="inputId + '-clear'" (mousedown)="$event.preventDefault()" (click)="set(null); panel.hide()">
      {{ (mode === 'pass' ? 'SETTINGS.LABELS.STAY.CLEAR_ROLE' : 'SETTINGS.LABELS.STAY.CLEAR_NONE') | translate }}
    </button>
  </div>
</p-popover>
